import React from 'react';
import { Box } from '@mui/material';
import { DragIndicator as DragIndicatorIcon } from '@mui/icons-material';

const ResizeHandle = ({ direction, onMouseDown }) => (
  <Box
    onMouseDown={onMouseDown}
    sx={{
      position: 'relative',
      cursor: direction === 'vertical' ? 'row-resize' : 'col-resize',
      backgroundColor: 'divider',
      zIndex: 10,
      '&:hover': {
        backgroundColor: 'primary.main',
      },
      ...(direction === 'vertical' 
        ? { height: '4px', width: '100%' }
        : { width: '4px', height: '100%' }
      )
    }}
  >
    <DragIndicatorIcon 
      sx={{ 
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontSize: 16,
        color: 'text.secondary',
        ...(direction === 'vertical' ? { transform: 'translate(-50%, -50%) rotate(90deg)' } : {})
      }} 
    />
  </Box>
);

export default ResizeHandle;
